module.exports = __webpack_public_path__ + "media/images/lb/260-6e0e062a4638c9d656a0f60776411ae2.svg";